import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const MaxWidthContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "720px",
    children: children
  });
};